// src/utils/colors.js
export const Colors = {
  // Brand
  brand: {
    primary: "#0b3c3f",      // main Fludee teal
    primaryDark: "#083134",
    accentBar: "#eaf3ff",    // small bar under header
  },

  // Backgrounds
  bg: {
    app: "#f6fafb",          // overall page background
    paper: "#ffffff",        // cards/drawers
    hover: "#f4f7f9",        // hover for list items
  },

  // Text
  text: {
    title: "#0b3c3f",
    body: "#2f4f51",
    muted: "#577476",
    sub: "#7f959c",
    placeholder: "#8aa0a7",
    icon: "#5a7b7d",
    header: "#0f2d2f",
  },

  // Borders / lines
  border: {
    light: "#e9eef3",
    input: "#b8c8cf",
    topLine: "#f3f6f9",
  },

  // Status
  status: {
    warning: "#f59e0b",
    danger: "#ef4444",
    success: "#22c55e",
    info: "#3b82f6",
  },

  // Shadows
  shadow: {
    brand: "0 10px 22px rgba(11,60,63,0.18)",
  },
};